function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "High-Fi-",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "REJ2--krok1-",
  transform: "translate(-25.000000, -752.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 414,
  height: 896
}), /*#__PURE__*/React.createElement("g", {
  id: "Row",
  transform: "translate(25.000000, 732.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Number",
  transform: "translate(0.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: 5,
  transform: "translate(0.000000, 1.200000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  opacity: 0.2,
  x: 5.76,
  y: 5.184,
  width: 10.32,
  height: 12.564
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.692,0.143992946 L3.792,0.143992946 C3.54678557,0.143992946 3.34782827,0.342785571 3.34782827,0.588 L3.34782827,18.648 C3.3446529,18.7667506 3.39035567,18.8816389 3.47435837,18.9656416 C3.55836108,19.0496443 3.6732494,19.0953471 3.792,19.0921717 L22.692,19.0921717 C22.8118213,19.0952396 22.927862,19.0498953 23.0137418,18.9662754 C23.0996217,18.8826555 23.1480438,18.7678651 23.148,18.648 L23.148,0.648 C23.1616584,0.518985148 23.1197159,0.390260238 23.0326744,0.294056483 C22.9456329,0.197852727 22.8217338,0.143279028 22.692,0.143992946 Z M14.16,15.036 C13.8290657,15.5639031 13.3487421,15.9815758 12.78,16.236 C12.121524,16.5364891 11.4036178,16.6841727 10.68,16.668 C10.0225989,16.6665711 9.36990134,16.5571125 8.748,16.344 C8.18063782,16.1771763 7.65369866,15.8953251 7.2,15.516 L7.92,13.896 C8.71752065,14.5257004 9.69998067,14.8756754 10.716,14.892 C11.916,14.892 12.516,14.364 12.516,13.296 C12.5401219,12.8472634 12.3695585,12.4099213 12.048,12.096 C11.7048243,11.7925963 11.2576919,11.6335203 10.8,11.652 C10.4548981,11.6518558 10.1128842,11.7170013 9.792,11.844 C9.45966126,11.9602374 9.15079634,12.13499 8.88,12.36 L7.56,12.36 L7.56,6.3 L14.136,6.3 L14.136,8.028 L9.744,8.028 L9.744,10.32 C10.2434179,10.0338198 10.8127276,9.89253124 11.388,9.912 C11.9778664,9.89870801 12.5610189,10.0393263 13.08,10.32 C13.5905615,10.5915928 14.0084072,11.0094385 14.28,11.52 C14.5390157,12.0409391 14.6628149,12.6186687 14.64,13.2 C14.6563981,13.8450262 14.489991,14.481533 14.16,15.036 L14.16,15.036 Z",
  id: "Shape",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4,21.456 L1.452,21.456 C1.12062915,21.456 0.852,21.1873708 0.852,20.856 L0.852,2.856 C0.852,2.52462915 1.12062915,2.256 1.452,2.256 L20.4,2.256 C20.7313708,2.256 21,2.52462915 21,2.856 L21,20.856 C21,21.1873708 20.7313708,21.456 20.4,21.456 Z M2.1,20.256 L19.752,20.256 L19.752,3.456 L2.052,3.456 L2.1,20.256 Z",
  id: "Shape",
  fill: "#555150"
}))))));

var SvgFifth = function SvgFifth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFifth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Fifth.71cb776c.svg";
export { ForwardRef as ReactComponent };